/* ============================================================================
   ChatPanel — col-right live chat. Polling messages verifies depuis l'API,
   render terminal sobre, share-link bar bottom.
   ============================================================================ */

import { useEffect, useState } from 'react';
import { usePolledMessages } from '../../lib/usePolledMessages';
import { MessageCard } from './MessageCard';
import { ShareLinkBar } from './ShareLinkBar';
import './chat.css';

function formatSync(lastSync: number | null, now: number): string {
  if (lastSync == null) return 'sync —';
  const diff = Math.max(0, now - lastSync);
  const sec = Math.floor(diff / 1000);
  if (sec < 5) return 'sync à l’instant';
  if (sec < 60) return `sync il y a ${sec}s`;
  const min = Math.floor(sec / 60);
  if (min < 60) return `sync il y a ${min}min`;
  return `sync il y a ${Math.floor(min / 60)}h`;
}

export function ChatPanel() {
  const { messages, error, lastSync, count, polling } = usePolledMessages(5000);

  // tick local 1s pour mettre a jour le compteur "sync" + formatRelative
  const [now, setNow] = useState(() => Date.now());
  useEffect(() => {
    const id = setInterval(() => setNow(Date.now()), 1000);
    return () => clearInterval(id);
  }, []);

  return (
    <div className="chat-root" data-testid="chat-root">
      <div className="chat-subhead" data-testid="chat-subhead">
        <span
          className={`chat-subhead__dot${polling ? ' chat-subhead__dot--live' : ''}`}
          aria-label={polling ? 'live polling actif' : 'polling en pause'}
        />
        <span>live</span>
        <span className="chat-subhead__sep">·</span>
        <span data-testid="chat-count">{count} message{count > 1 ? 's' : ''}</span>
        <span className="chat-subhead__sync" data-testid="chat-sync">
          {formatSync(lastSync, now)}
        </span>
      </div>

      {error && (
        <div className="chat-error" role="alert" data-testid="chat-error">
          ✗ connexion API perdue. retry dans 4s.
        </div>
      )}

      {messages.length === 0 && !error ? (
        <div className="chat-empty" data-testid="chat-empty">
          encore aucun message.
          <br />
          partage le lien pour recevoir.
        </div>
      ) : (
        <div className="chat-list" data-testid="chat-list">
          {messages.map((m) => (
            <MessageCard key={m.id} message={m} now={now} />
          ))}
        </div>
      )}

      <ShareLinkBar />
    </div>
  );
}
